import React, { useState, useEffect, useContext, useRef,useCallback} from "react";
import DatePicker from "react-datepicker";

//import ChartColumn from './../../components/chart/column';
import ProgressChart from "../chart/progresschart.js";
import ReportCreate from "../chart/reportCreator";
import Piechart from "../chart/piechart.js";
import moment from "moment";
import RenderButton from "../common/button";
import BranchContext from "../context/branch";
import Header from "./header";
import ScrollToTop from "./../common/ScrollToTop";
import Renderdetails from "./rendercockdetail";
import { toast } from 'react-toastify';
import {getInoutperhour,GetlogDetail,getDeviceName,getFaceScanByDate} from './../../services/facescan';


  const Reportregister = (props) => {
    const [Id, setId] = useState(props.match.params.id);
  const { currentBranch } = useContext(BranchContext);
  const [startDate, setStartDate] = useState(new Date());

  const [value, setValue] = useState(14);
  const [total,setTotal] = useState(0);
  const [id, setid] = useState(0);
  const [hour, sethour] = useState(0);
  const [amountcompare, setAmountcompare] = useState([]);
  const [devicelist, setdevicelist] = useState([]);
  const [scanlist, setscanlist] = useState([]);
  const [data1, setData1] = useState({});

  const [chartdatapermit, setchartdatapermit] = useState([]);


  const [chartdatahour, setchartchartdatahour] = useState([]);
  const [graphtype, setgraphtype] = useState("bar");
  const [devicename, setdevicename] = useState("");
  const [scanamount, setscanamount] = useState("0");
  const [scanperson, setscanperson] = useState("0");
  const [showonscroll, setshowonscroll] = useState(false)
  const [onprocess, setonprocess] = useState(false)
  const [pageSize, setPageSize] = useState(2000);
  const [statusId,setstatusid] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [detials, setdetials] = useState([]);


  useEffect(() => {

    if (!currentBranch) return;
   
    setdetials([]);
  }, [currentBranch,
    startDate,pageSize,showonscroll,id,hour
   ]);


   useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {

      const { data: result } = await getDeviceName(Id)
  
        if (result.status === "success") {
         
          setdevicelist(result.data.list);
        }else if (result.status ==="error") {
          setdevicelist([]);
          toast.error(result.message)     
        }
    };
    loadData();
  }, [currentBranch, Id]);



  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {

      const { data: result } = await getFaceScanByDate( moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),Id)
  
        if (result) {
         //console.log(result)
          setscanlist(result);
          
        }
    };
    loadData();
  }, [currentBranch, startDate,Id]);


  useEffect(() => {
    if (!currentBranch) return;
    if (!(scanlist.length)) return;

    const loadData =  () => {

      setscanamount(scanlist[0].amount)
      setscanperson(scanlist[0].person)
     
    };
    loadData();
  }, [currentBranch, scanlist]);

  useEffect(() => {
    if (!currentBranch) return;
    if (!(devicelist.length)) return;

    const loadData =  () => {
      setdevicename(devicelist[0].name);
     
    };
    loadData();
  }, [currentBranch, devicelist]);


  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {

      const { data: result } = await GetlogDetail(id,value,hour,
        moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
        pageSize,
        pageNumber
       )
  
        if (result.status === "success") {
          setTotal(result.data.total);
        //  console.log(result.data.list)
          
          setdetials(result.data.list);
        // setdetials(prevData => {   
        //              return [...new Set([...prevData, ...result.data.list])]
        //                           })
                           setHasMore(result.data.list.length > pageSize-1)
                           setLoading(false)  
        }else if (result.status ==="error") {
          setdetials([]);

        
          toast.error(result.message)
    
          
        }
    };
    loadData();
  }, [currentBranch, value,startDate, id,hour,pageSize,
    pageNumber,showonscroll]);

    const observer = useRef();
    const lastBookElementRef = useCallback(
      (node) => {
  
           if (node && node.offsetTop > 0){
            setshowonscroll(true);
           }
        if (loading) return;
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting && hasMore) {
            setPageNumber((prevPageNumber) => prevPageNumber + 1);
  
          
  
          }
        });
        if (node) observer.current.observe(node);
      },
      [loading, hasMore]
    );
  

  // useEffect(() => {
  //   if (!currentBranch) return;

  //   const loadData = async () => {
  //     const { data: result } = await getCompareEmpSD(
  //       moment(startDate, "YYYY-MM-DD").add(0, "day").format("YYYY-MM-DD"),
  //       value
  //     );
  //     if (result) {
  //       setchartdatacompare(result);
  //       //  console.log(result);
  //     }
  //   };
  //   loadData();
  // }, [currentBranch, startDate, value]);

  // useEffect(() => {
  //   if (!currentBranch) return;

  //   const loadData = async () => {
  //     const { data: result } = await getCompareFaceSD(
  //       moment(startDate, "YYYY-MM-DD").add(0, "day").format("YYYY-MM-DD"),
  //       value
  //     );
  //     if (result) {
  //       setchartdatapermit(result);
  //     }
  //   };
  //   loadData();
  // }, [currentBranch, startDate, value]);

  // useEffect(() => {
  //   if (!currentBranch) return;

  //   const loadData = async () => {
  //     const { data: result } = await getCompareCompany(
  //       moment(startDate, "YYYY-MM-DD").add(0, "day").format("YYYY-MM-DD"),
  //       value
  //     );
  //     if (result) {
  //       setcomparecompany(result);
  //       //  console.log(result);
  //     }
  //   };
  //   loadData();
  // }, [currentBranch, startDate, value]);
  // useEffect(() => {
  //   if (!currentBranch) return;

  //   const loadData = async () => {
  //     const { data: result } = await getCompareTotal(
  //       moment(startDate, "YYYY-MM-DD").add(0, "day").format("YYYY-MM-DD"),
  //       value
  //     );
  //     if (result) {
  //       setcomparetotal(result);
  //       //  console.log(result);
  //     }
  //   };
  //   loadData();
 // }, [currentBranch, startDate, value]);

  // useEffect(() => {
  //   if (!currentBranch) return;

  //   const loadData = async () => {
  //     const { data: result } = await getProgressPlan(value);
  //     if (result) {
  //       setprogressplan(result);
  //     }
  //   };
  //   loadData();
  // }, [currentBranch, value]);

  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {
      const { data: result } = await getInoutperhour(
        moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),Id
      );
      if (result) {
        setchartchartdatahour(result);

        //console.log(result);
      }
    };
    loadData();
  }, [currentBranch, startDate,Id]);

  const handleChange = (event) => {
    setValue(event);
  };

 



  useEffect(() => {
    if (!chartdatahour || !currentBranch) return;
    const chart = () => {
      let phour = [];

      let AmountA = [];
      

      for (const dataObj of chartdatahour) {
        phour.push(dataObj.hour);

        AmountA.push(parseInt(dataObj.AmountIN));
        
      }

      const data =
      {
        series: [
          { name: "เข้า", data: AmountA }
          
        ],
        yLabels: phour,
        headers:
          "ข้อมูลเข้าออกรายชั่วโมง (คน) วันที่ " +
          moment(startDate, "YYYY-MM-DD").format("DD-MM-YYYY"),
        type: "bar",
        stacked: false,
      };
const data2 = { 

  series: [
    { name: "REC", data: AmountA },
    
  ],
  yLabels: phour,
  headers:
    "ข้อมูลเข้าออกรายชั่วโมง (คน) วันที่ " +
    moment(startDate, "YYYY-MM-DD").format("DD-MM-YYYY"),
  type: "bar",
  stacked: false,

}
if (value==2){
  setData1(data2);
}else {
  setData1(data);
}

     
    };
    chart();
  }, [chartdatahour, currentBranch,startDate,value]);

  const chartopions = {
    theme: {
      mode: "light",
      palette: "palette8",
      monochrome: {
        enabled: false,
        color: "#255aee",
        shadeTo: "light",
        shadeIntensity: 0.65,
      },
    },
  };



  const handleonClick = (hour,Id) => {
    setPageSize(1);
    setid(Id);
    sethour(hour);
    
//console.log(date,action);
  }


  
  if (
    !currentBranch ||
    
    data1.series == undefined 
  ) {
    return <></>;
  }
  // if (chartdatacomparetotal.series[0].length == 0){

  //   return <></>;
  // }

  //console.log(chartdatacomparecompany)
  return (
    <div className="row container-fluid">
      <div className="col-12">
        <div className="container">
          <div className="row">
            <div className="m-4">
              <div className="mt-2" style={{ marginTop: 20, marginBottom: 20 }}>
                <DatePicker
                  todayButton="Today"
                  dateFormat="dd/MM/yyyy"
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                />
              </div>
            </div>
            <div className="col-auto">
              <div className="m-2">
                <i>
                  เครื่อง  <span className="label label-default"></span>
                </i>
                <div
                  className="mt-2"
                  style={{ marginTop: 20, marginBottom: 20 }}
                >
                <span className="badge bg-warning"  style={{ fontSize: "14px" }} > { devicename }   </span>   
                </div>
              </div>
            </div>

            <div className="col-md-2 ">
                
                <button
                  className="btn btn-secondary    d-flex justify-content-center"
                  style={{ height: 80, width: 170}}
                  type="button"
                >
                  <div className="container m-2">
                    <h5>ครั้ง</h5>
                    <h5>{scanamount}</h5>
                  </div>
                </button>
                </div>
               
                <div className="col-md-2  ">
              
                <button
                  className="btn btn-info   d-flex justify-content-center"
                  style={{ height: 80, width: 170}}
                  type="button"
                >
                  <div className="container m-2">
                    <h5>คน</h5>
                    <h5>{scanperson}</h5>
                  </div>
                </button>
                </div>
              
                {/* <div className="col-md-2  ">
               
               <button
                 className="btn btn-success   d-flex justify-content-center"
                 style={{ height: 80, width: 170}}
                 type="button"
               >
                 <div className="container m-2">
                   <h5>ทำงาน</h5>
                   <h5>254</h5>
                 </div>
               </button>
               </div> */}

          </div>
        </div>

        {/* <div className="row">
<div className="col-md-6">
<div className="mt-1">
          <Piechart data={data2} options = {pie}  />
        </div>
</div>

<div className="col-md-6">
<div className="mt-1">
          <ReportCreate data={data1} stacked={true} />
        </div>
</div>


</div> */}
        {/* <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="mt-1">
              <div className="card">
                <div className="card-header text-center">
                  สถานะวันทำงาน เทียบปัจจุบัน
                </div>
                <div className="card-body text-center">
                  <ProgressChart
                    labels={["ทำงานมาแล้ว"]}
                    donutData={chartprogressplan}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="mt-1">
              <div className="card">
                <div className="card-header text-center">
                  Scan หน้า /เทียบ ไม่ Scan (ขอเข้าทำงาน) ภาพรวม
                </div>
                <div className="card-body text-center">
                  <Piechart
                    labels={chartdatacomparetotal.yLabels}
                    Datachart={chartdatacomparetotal.series[0]}
                    chartOptions={chartopions}
                  />
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {/* <div className="mt-1">
          <ReportCreate
            data={data3}
            type={graphtype}
            labelposition="top"
            palette={"palette6"}
          />
        </div> */}

        {/* <div className="mt-1">
          <ReportCreate
            data={data2}
            type={graphtype}
            stacked={true}
            labelposition="top"
          />
        </div> */}

        {/* <div className="mt-1">
          {
            <ReportCreate
              data={chartdatacomparecompany}
              type={graphtype}
              stacked={false}
              labelposition="top"
              palette={"palette6"}
            />
          }
        </div> */}

        {/* <div className="mt-1">
          {
            <ReportCreate
              data={chartdatacompanydate}
              type={graphtype}
              stacked={false}
              labelposition="top"
              palette={"palette6"}
            />
          }
        </div> */}

      
        <div className="mt-1">
          <ReportCreate
            data={data1}
            type={graphtype}           
            labelposition="top"
            palette={"palette6"}
            onclick={handleonClick}
          />
        </div>

        {/* <p className="text-primary">
       Click Graph เพื่อแสดงข้อมูล ข้อมูล {detials ? detials.length : 0}  /  {total} รายการ
      </p>
       


       <Renderdetails
         list={detials}
         loading={loading}
         error={error}
         lastBookElementRef={lastBookElementRef}
         
       /> */}
 <ScrollToTop 
       
       />
      </div>
    </div>
  );
};

export default Reportregister;
